import { useState } from "react";
import FilterComponent from "../../../../ReusableFIlterComponent/FilterComponent";
import { useSelector } from "react-redux";
import { setSelectedFeatures, setSelectedGroups } from "../../../../../features/themeSlice";
import { useDispatch } from "react-redux";
import { Box } from "@mui/system";

export default function ThemeFilter({ clearSelectedTheme }: any) {

    const {
      selectedFeatures,
      selectedGroups,
      designThemesData,
    } = useSelector((state: any) => state?.theme);

    const dispatch = useDispatch();

  const [searchFeature,setSearchFeature] = useState('');
  const [searchGroup,setSearchGroup] = useState('');

  const filterConfig = [
    {
      key: 'Groups',
      label: 'Select one or more Groups',
      searchTerm: searchGroup,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchGroup(e.target.value),
      selectedOption: selectedGroups,
      filterName: 'groups_appearance',
      data: designThemesData,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedGroups(updatedSelection)),
      count: selectedGroups && selectedGroups.length,
      colorSelected: selectedGroups !== null && selectedGroups.length > 0 ? '#9C27B0' : '#000000DE',
      multiSelect: true,
      showSearch: true,
    },
    {
      key: 'features',
      label: 'Select one or more Feature',
      searchTerm: searchFeature,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => setSearchFeature(e.target.value),
      selectedOption: selectedFeatures,
      filterRoot:["templates"], // labels are not in directly in data
      filterName: 'labels',
      data: designThemesData,
      onSelectionChange: (updatedSelection: any) => dispatch(setSelectedFeatures(updatedSelection)),
      count: selectedFeatures && selectedFeatures.length,
      colorSelected: selectedFeatures !== null && selectedFeatures.length > 0 ? '#9C27B0' : '#000000DE',
      multiSelect: true,
      showSearch: true,
    }
  ];

  const clearFilters = () => {
    dispatch(setSelectedGroups(null));
    dispatch(setSelectedFeatures(null));
    clearSelectedTheme(null);
    setSearchFeature('');
    setSearchGroup('');
  };

 
  return (
    <Box data-tracker="136">
      <FilterComponent filterConfig={filterConfig} clearFilters={clearFilters} />
    </Box>
  );
}
